<template>
  <section class="section-login">
    <template v-if="bookingState.selectedProfessional && $route.path === '/booking/choose-cleaner'">
      <div class="row mb-3">
        <div class="col-12 text-center">
          <h3>{{ $t('message.login.please_login_to_continue') }}</h3>
        </div>
      </div>
    </template>
    <div class="row" v-if="displayBenefits">
      <div class="col-12">
        <h3>{{ $t('message.login.benefits.title') }}</h3>
        <!-- <p>{{ $t('message.login.benefits.detail') }}</p> -->
        <hr>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <button class="button-large button-block button-login -indigo" @click="preLogin('facebook')">
          <i class="fab fa-facebook-f"></i>&nbsp;&nbsp;&nbsp;<label>{{ $t('message.login.login_with_facebook')
          }}</label>
        </button>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <button class="button-large button-block button-login -red" @click="preLogin('googleplus')">
          <i class="fab fa-google"></i>&nbsp;&nbsp;&nbsp;<label>{{ $t('message.login.login_with_google') }}</label>
        </button>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <button class="button-large button-block button-login btn-dark" @click="preLogin('apple')">
          <i class="fab fa-apple fa-lg"></i>&nbsp;&nbsp;&nbsp;<label>{{ $t('message.login.login_with_apple') }}</label>
        </button>
      </div>
    </div>
    <div class="background my-3">
      <span>{{ $t('message.login.or') }}</span>
    </div>
    <div class="row">
      <div class="col-12 text-left">
        <div class="form-group">
          <input type="email"
                 class="form-control input-lg"
                 :class="{'form-alert': errorEmail}"
                 @input="updateFormData('email', $event)"
                 :placeholder="$t('message.login.email')"
                 v-model="userEmail">
          <div v-if="errorEmail" class="form-alert-text -status-alert">{{ errorEmailText }}</div>
        </div>
        <div class="form-group">
          <input type="password"
                 maxlength="20"
                 class="form-control input-lg"
                 :class="{'form-alert': errorPassword}"
                 @input="updateFormData('password', $event)"
                 @keyup.enter.prevent="preLogin('email')"
                 :placeholder="$t('message.login.password')"
                 v-model="userPassword"
                 @keyup.enter="preLogin('email')">
          <div v-if="errorPassword" class="form-alert-text -status-alert">
            {{ errorPasswordText }}
          </div>
        </div>
        <div class="form-group">
          <button class="button-large button-block -cyan" @click="preLogin('email')">
            <label>{{ isLoggingIn ? $t('message.button.loading') : $t('message.button.login') }}</label>
          </button>
        </div>
        <div class="text-center">
          <a href="" @click.prevent="displayForm('reset-password')">{{ $t('message.login.forgot_password') }}</a>
        </div>
      </div>
    </div>
    <hr>
    <p>
      {{ $t('message.login.dont_have_account') }}
      <a href="" @click.prevent="displayForm('register')">{{ $t('message.login.sign_up') }}</a>
    </p>

  </section>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { firebaseAuth } from '../../helpers/firebaseHelpers'
import { signInWithPopup, signInWithEmailAndPassword, FacebookAuthProvider, GoogleAuthProvider, OAuthProvider } from 'firebase/auth'
import { SweetModal } from 'sweet-modal-vue'
import axios from 'axios'
export default {
  data () {
    return {
      userEmail: null,
      userPassword: null,
      errorEmailText: null,
      errorPasswordText: null,
      errorEmail: false,
      errorPassword: false,
      loginData: {
        social_id: null,
        firstname: null,
        lastname: null,
        email: null,
        picture: null,
        social_name: null,
        token: null
      }
    }
  },
  components: {
    SweetModal
  },
  computed: {
    ...mapState({
      langState: state => state.globalVal.currentLanguage
    }),
    ...mapState('auth', ['isLoggingIn']),
    ...mapGetters({
      bookingState: 'booking/getState',
      isCheckingEmailAccount: 'auth/getIsCheckingEmailAccount',
      state: 'auth/getState',
      user: 'auth/getUser',
      referralCode: 'auth/getReferralCode'
    }),
    displayBenefits () {
      return (this.user === null && this.$route.path === '/booking/start')
    }
  },
  watch: {
    isCheckingEmailAccount () {
      if (!this.isCheckingEmailAccount) {
        if (this.state.registeredPlatform) {
          const platform = this.state.registeredPlatform
          if (platform !== 'email_password') {
            const message = this.$i18n.t('message.alert.login_with_other_options', { platform: platform.charAt(0).toUpperCase() + platform.slice(1) })
            this.$parent.$parent.confirmLoginThrough(message, platform)
          } else {
            this.emailPasswordLogin()
          }
        } else {
          const message = this.$i18n.t('message.alert.no_username')
          this.showAlertMessage(message)
        }
      }
    }
  },
  methods: {
    showAlertMessage (message) {
      this.$parent.$parent.showAlertMessage(message)
    },
    preLogin (platform) {
      if (platform !== 'email') {
        this.socialLogin(platform)
      } else {
        if (this.validation()) {
          const submitData = {
            email: this.userEmail
          }
          this.$store.dispatch('auth/CHECK_EMAIL_ACCOUNT', submitData)
        }
      }
    },
    async socialLogin (platform) {
      let provider
      let validation = false
      if (platform === 'facebook') {
        provider = new FacebookAuthProvider()
        provider.addScope('email')
        validation = true
      } else if (platform === 'googleplus') {
        provider = new GoogleAuthProvider()
        provider.addScope('profile')
        provider.setCustomParameters({
          'login_hint': 'user@example.com'
        })
        validation = true
      } else if (platform === 'apple') {
        provider = new OAuthProvider('apple.com')
        provider.addScope('email')
        provider.addScope('name')
        validation = true
      }
      if (validation) {
        try {
          // Login with firebase
          const result = await signInWithPopup(firebaseAuth, provider)
          this.settingUpLogIn(result)
          // Set current login path
          // this.setCurrentLoginPath()

          // this.setIsLoggingIn()
        } catch (error) {
          const errorCode = error.code
          const errorMessage = error.message
          const email = error.customData.email

          let credential = null
          if (platform === 'facebook') {
            credential = FacebookAuthProvider.credentialFromError(error)
          } else if (platform === 'googleplus') {
            credential = GoogleAuthProvider.credentialFromError(error)
          } else if (platform === 'apple') {
            credential = OAuthProvider.credentialFromError(error)
          }
          console.error('code:', errorCode, ' errorMessage: ', errorMessage, email, credential)
          this.showAlertMessage('Error: Something went wrong, please contact us.')
        }
      } else {
        this.showAlertMessage('No User')
      }
    },
    async settingUpLogIn (result) {
      if (result && result.user) {
        // The signed-in user info.
        const user = result.user
        // Set data before logging in
        this.loginData.email = user.email
        this.loginData.picture = 'https://beneat.co/images/ic_unknown.png'
        this.loginData.token = user.refreshToken
        this.loginData.social_id = user.uid
        let socialName = null
        switch (result.providerId) {
          case 'google.com': {
            socialName = 'googleplus'
            let displayNameArr
            if (user.displayName) {
              displayNameArr = user.displayName.split(' ')
            } else {
              const providerData = user.providerData
              if (providerData && providerData.length > 0) {
                const googleAccount = providerData.find(item => item.providerId === 'google.com')
                displayNameArr = googleAccount.displayName.split(' ')
              }
            }
            this.loginData.firstname = displayNameArr[0]
            this.loginData.lastname = displayNameArr[1]
            this.loginData.picture = `${user.photoURL}?size=200`
            this.loginData.social_name = socialName
            // Login BeNeat App
            await this.loginApp()
          }
            break
          case 'facebook.com': {
            socialName = 'facebook'
            // This gives you a Facebook Access Token. You can use it to access the Facebook API.
            const credential = FacebookAuthProvider.credentialFromResult(result)
            const accessToken = credential.accessToken
            const url = `https://graph.facebook.com/me?fields=first_name,last_name,email&access_token=${accessToken}`
            const { data } = await axios.get(url)
            if (data) {
              this.loginData.firstname = data.first_name
              this.loginData.lastname = data.last_name
              this.loginData.picture = `https://graph.facebook.com/${data.id}/picture?width=200&height=200`
              this.loginData.email = data.email
              this.loginData.social_id = data.id
              this.loginData.social_name = socialName
              if (!data.email) {
                // Close Loader Modal
                this.$emit('closeModal')
                // Open Request Email Modal
                this.$emit('openAppModal', 'request-email')
              } else {
                // Login BeNeat App
                await this.loginApp()
              }
            }
          }
            break
          case 'apple.com': {
            socialName = 'apple'

            let displayNameArr = ''
            let name = ''
            // ถ้ามี displayName ให้เอามาเก็บได้เลย
            if (user.displayName) {
              displayNameArr = user.displayName.split(' ')
              this.loginData.firstname = displayNameArr[0]
              this.loginData.lastname = displayNameArr[1] || ''
            } else {
              // แต่ถ้าไม่มีให้เอา username email มาเป็นชื่อในระบบ
              const email = user.email
              const nameMatch = email.match(/^([^@]*)@/)
              name = nameMatch ? nameMatch[1] : user.uid
              this.loginData.firstname = name
              this.loginData.lastname = ''
            }
            this.loginData.social_id = user.uid
            this.loginData.social_name = socialName

            // Login BeNeat App
            await this.loginApp()
          }
            break
        }
      } else {
        this.$emit('closeModal')
      }
    },
    async loginApp () {
      let submitData = { ...this.loginData, referral_code: this.referralCode }
      try {
        await this.$store.dispatch('auth/LOGIN', submitData)
        // Close Modal
        this.$emit('closeModal')
      } catch (err) {
        this.showAlertMessage('Error: Something went wrong, please contact us.')
      }
    },
    emailPasswordLogin () {
      const email = this.userEmail
      const password = this.userPassword
      if (email && password) {
        signInWithEmailAndPassword(firebaseAuth, email, password).then(user => {
          this.setIsLoggingIn()
          const loginData = {
            email: this.userEmail,
            social_name: 'email_password',
            token: null
          }
          this.$store.dispatch('auth/LOGIN', loginData)
        }).catch(error => {
          const errorCode = error.code
          let errorMessage = error.message

          if (errorCode === 'auth/wrong-password') {
            errorMessage = this.$i18n.t('message.alert.wrong_password')
          }
          this.showAlertMessage(errorMessage)
        })
      }
    },
    validation () {
      let result = true
      const emailFormat = new RegExp('^([a-zA-Z0-9\\+_\\-]+)(\\.[a-zA-Z0-9\\+_\\-]+)*@([a-z0-9\\-]+\\.)+[a-z]{2,6}$')

      if (!this.userEmail) {
        this.errorEmailText = this.$i18n.t('message.login.email_is_required')
        this.errorEmail = true
        result = false
      } else if (this.userEmail && !emailFormat.test(this.userEmail)) {
        this.errorEmailText = this.$i18n.t('message.login.invalid_email_address')
        this.errorEmail = true
        result = false
      }

      if (!this.userPassword) {
        this.errorPasswordText = this.$i18n.t('message.login.password_is_required')
        this.errorPassword = true
        result = false
      }

      return result
    },
    updateFormData (attribute, e) {
      if (attribute === 'email') {
        this.errorEmail = false
      } else {
        this.errorPassword = false
      }
    },
    displayForm (formType) {
      this.$store.commit('auth/SET_LOGIN_FORM_TYPE', formType)
    },
    setIsLoggingIn () {
      window.localStorage.setItem('isLoggingIn', 'true')
    },
    setCurrentLoginPath () {
      if (this.$route.matched[0].path === '/cleaner/:id' && this.bookingState.selectedProfessional) {
        this.$store.commit('globalVal/SET_CURRENT_LOGIN_PATH', this.$route.matched[0].path)
        // Redirect to home page to prevent clearing vuex data
        this.$router.push('/')
      } else {
        this.$store.commit('globalVal/SET_CURRENT_LOGIN_PATH', this.$route.path)
      }
    }
  },
  mounted () {
    this.$store.commit('auth/REQUEST_LOGIN', false)
    // Clear login data
    this.userEmail = null
    this.userPassword = null
  }
}
</script>



// WEBPACK FOOTER //
// src/components/login/LoginForm.vue